export default function OurFocus() {
  const features = [
    {
      icon: 'ri-moon-line',
      title: 'Muslim-Friendly Excellence',
      description: 'Hand-picked accommodations near mosques, halal dining, and culturally respectful environments for families',
      link: '#muslim-friendly'
    },
    {
      icon: 'ri-compass-3-line',
      title: 'Personalised Travel Advisory',
      description: 'From first enquiry to final return, our advisors remain closely involved, managing every detail with precision',
      link: '#assistance'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Curated Premium Stays',
      description: 'Verified accommodations across Saudi Arabia, Middle East, and Turkey—chosen for quality, safety, and family comfort',
      link: '#accommodations'
    }
  ];

  return (
    <section className="py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-[#C9A961]/10 rounded-full mb-4">
            <span className="text-[#C9A961] text-sm font-semibold">Why Alwaz Travel London</span>
          </div>
          <h2 className="text-5xl lg:text-6xl font-bold text-[#1A1F2E] mb-6 leading-tight" style={{ fontFamily: 'Playfair Display, serif' }}>
            Crafted Journeys,<br />Delivered with Care
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed">
            We curate hand-selected stays and manage every detail with precision, ensuring seamless, meaningful travel experiences
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group bg-white rounded-3xl p-8 shadow-sm hover:shadow-xl transition-all duration-300 hover:-translate-y-2 hover:bg-[#F8F6F0] cursor-pointer"
            >
              <div className="w-16 h-16 bg-[#C9A961] rounded-full flex items-center justify-center mb-6 group-hover:bg-[#B89851] transition-colors">
                <i className={`${feature.icon} text-2xl text-white`}></i>
              </div>
              <h3 className="text-2xl font-bold text-[#1A1F2E] mb-4">{feature.title}</h3>
              <p className="text-gray-600 mb-6 leading-relaxed">{feature.description}</p>
              <a href={feature.link} className="text-[#C9A961] font-semibold flex items-center gap-2 hover:gap-3 transition-all whitespace-nowrap">
                Learn More <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
